import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'

import setReminderIcon from '../../../../images/set-reminder.svg'
import styles from './rental-notes.css'

function RentalNotes({ timeToBeginWatch, hoursFromFirstPlay }) {
  return (
    <div className={styles.container}>
      <ReactSVG
        src={setReminderIcon}
        beforeInjection={svg => {
          svg.setAttribute('class', styles.disclaimerIcon)
        }}
        className={styles.svgWrapper}
      />

      <div className={styles.content}>
        { timeToBeginWatch && <span className={styles.timeToBeginWatchingText}>{timeToBeginWatch}</span> }
        { hoursFromFirstPlay && <span>{hoursFromFirstPlay}</span> }
      </div>
    </div>
  )
}

RentalNotes.propTypes = {
  timeToBeginWatch: PropTypes.string,
  hoursFromFirstPlay: PropTypes.string
}

RentalNotes.defaultProps = {
  timeToBeginWatch: null,
  hoursFromFirstPlay: null
}

export default RentalNotes
